import Box from '@mui/system/Box'
import i18next from 'i18next'
import { useTranslation } from 'react-i18next'
import type { ProductEntity } from '../../../api/service-manager.ts'
import { Tooltip } from '../../../components/generic.tsx'
import { ids } from '../../../ids.ts'

export const SubscriptionStatusIcon = ({ status, trial }: { status: ProductEntity['status']; trial?: boolean }) => {
	const { t } = useTranslation()
	const subscriptionStatus = trial && status === 'Active' ? 'trial' : status.toLocaleLowerCase()
	return (
		<Tooltip title={t(($) => $.smp.accountDetails.subscriptionStatus[subscriptionStatus as 'trial' | 'active' | 'suspended' | 'canceled'])}>
			<Box
				data-ta={ids.smp.accounts.accountDetails.status}
				flexShrink={0}
				sx={{
					height: 8,
					width: 8,
					borderRadius: '50%',
					bgcolor: `subscriptionStatus.${subscriptionStatus}`,
				}}
			/>
		</Tooltip>
	)
}

export const formatCharacteristicName = (characteristic: Pick<ProductEntity['productCharacteristics'][number], 'name'>) => {
	switch (characteristic.name) {
		case 'USERS':
			return i18next.t(($) => $.smp.accountDetails.characteristics.users)
		case 'DEVICES':
			return i18next.t(($) => $.smp.accountDetails.characteristics.devices)
		case 'PROTECTED_ASSETS':
			return i18next.t(($) => $.smp.accountDetails.characteristics.protectedAssets)
		case 'XCAST_SERVICE':
			return i18next.t(($) => $.smp.accountDetails.characteristics.xcastService)
		case 'ANALYZE':
			return i18next.t(($) => $.smp.accountDetails.characteristics.analyze)
		case 'SERVICE_USERS':
			return i18next.t(($) => $.smp.accountDetails.characteristics.serviceUsers)
		case 'MAP_LAYERS':
			return i18next.t(($) => $.smp.accountDetails.characteristics.mapLayers)
		case 'ALERT_API':
			return i18next.t(($) => $.smp.accountDetails.characteristics.alertApi)
		case 'WEB_RELAYS':
			return i18next.t(($) => $.smp.accountDetails.characteristics.webRelays)
		default:
			return undefined
	}
}
